module.exports = __webpack_public_path__ + "static/media/steps_arrow.5fb4f359.svg";